import {  usuarioConstantes } from '@actions/types';


const initialState = {
  verificando: false,
  token: ''
}


export default function verifyUserReducer(state = initialState, action) {
  switch (action.type) {
    case usuarioConstantes.VERIFY_USER_REQUEST:
      return {
        verificando : true,
        token: action.token
      };
    case usuarioConstantes.VERIFY_USER_SUCCESS:
      return {
        verificando: false,
        token: ''
      };
    case usuarioConstantes.VERIFY_USER_FAILURE:
      return {
        verificando: false,
        token: ''
      };
    default:
      return state
  }
}
